import classNames from "classnames";
import PropTypes from "prop-types";
import { PureComponent, cloneElement } from "react";
import styles from "./hoverablePopoverTrigger.module.scss";

// Custom solution to manage the hovering of a bootstrap popover.
//
// In the basic solution (using an OverlayTrigger), when trying to select anything in the popover,
// the popover disapear (because the cursor is not in the triggered element anymore).
// See https://github.com/react-bootstrap/react-bootstrap/issues/1622

class HoverablePopoverTrigger extends PureComponent {
  constructor(props: any) {
    super(props);
    this.state = { popoverFullyHidden: true, popoverDisplayed: false };

    this.hideTimeout = null;
  }

  handleMouseEnter() {
    this.setState({ popoverFullyHidden: false, popoverDisplayed: true });

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  handleMouseLeave() {
    this.setState({ popoverDisplayed: false });
    this.hideTimeout = setTimeout(
      () => this.setState({ popoverFullyHidden: true }),
      250,
    );
  }

  handleClickPopover = () => {
    // e.stopPropagation();
  };

  render() {
    const popoverClassName = classNames(
      this.props.popoverClassName,
      this.props.placement,
      "fade",
      { in: this.state.popoverDisplayed },
      { hidden: this.state.popoverFullyHidden },
    );

    return (
      <div
        className={styles.popover_container}
        onMouseEnter={() => this.handleMouseEnter()}
        onMouseLeave={() => this.handleMouseLeave()}
      >
        {this.props.children}
        {cloneElement(this.props.popover, {
          className: popoverClassName,
          placement: this.props.placement,
          // onClick: (e) => this.handleClickPopover(e),
        })}
      </div>
    );
  }
}

HoverablePopoverTrigger.displayName = "HoverablePopoverTrigger";

HoverablePopoverTrigger.propTypes = {
  children: PropTypes.element.isRequired,
  placement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
};

HoverablePopoverTrigger.defaultProps = {
  placement: "right",
};

export default HoverablePopoverTrigger;
